import { createComponent, MicrofrontendContext } from '@cian/mf-react';
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { IMicrofrontend } from '@cian/mf-registry/shared/microfrontend/types';
import { useApplicationContext } from '../../../ApplicationContext';
import { useDispatch } from 'react-redux';
import { changePromotionService, checkServiceSuccess, loadPublishTermsSuccess } from '../../../../redux/reducers';
import { PayPackageContainer } from '../../containers/PayPackage/PayPackage';
import { usePaymentEvents } from './usePaymentEvents';

const ServicePickerWidgetMicrofrontend = createComponent({
  mcs: 'service-picker-widget-frontend',
  path: '/public/v1/get-microfrontend/',
});

export const ServicePickerWidget = () => {
  const { microfrontend } = useApplicationContext();
  const dispatch = useDispatch();

  usePaymentEvents();

  const handleServicesChange = useCallback(
    e => {
      const detail = e.detail;
      const response = detail.response;

      if (response.success) {
        const {
          selectedPromotionInfo: { serviceId },
        } = response;

        if (detail.isAuctionSelected) {
          dispatch(changePromotionService(serviceId));
        }

        dispatch(checkServiceSuccess(response.payload));
      }

      dispatch(
        loadPublishTermsSuccess({
          publishTerms: detail.publishTerms,
          replace: true,
          auction: response.auction,
          recommendedPackages: detail.recommendedPackages,
          termsDurations: detail.termsDurations,
          moneySource: detail.moneySource,
          calltracking: detail.calltracking,
          withoutPromotion: !detail.isServicesEnabled,
          withoutMinimalBet: response.payload.withoutMinimalBet,
        }),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    window.addEventListener('service-picker-widget/check-service', handleServicesChange);

    return () => {
      window.removeEventListener('service-picker-widget/check-service', handleServicesChange);
    };
  }, [handleServicesChange]);

  return (
    <MicrofrontendContext.Provider value={microfrontend as IMicrofrontend}>
      <ServicePickerWidgetMicrofrontend />
      <PayPackageContainer />
    </MicrofrontendContext.Provider>
  );
};
